"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var ScrollItemsWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\ttransition-property: transform;\n\theight: 100%;\n\twidth: 100%;\n\ttransition-timing-function: cubic-bezier(0, 0, 0.25, 1);\n"], ["\n\tdisplay: flex;\n\ttransition-property: transform;\n\theight: 100%;\n\twidth: 100%;\n\ttransition-timing-function: cubic-bezier(0, 0, 0.25, 1);\n"])));
var Children = React.Children;
var BetterSwipe = (function (_super) {
    __extends(BetterSwipe, _super);
    function BetterSwipe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentIndex: _this.props.defaultIndex || 1,
            animationDuration: 0,
            dragPoints: null,
            wrapperOffsetLeft: 0,
            startTime: 0
        };
        _this.timeoutId = null;
        _this.windowScrollTimeoutId = 0;
        _this.isStop = false;
        _this.onTransitionEnd = function () {
            var _a = _this.props, children = _a.children, onIndexChange = _a.onIndexChange;
            var currentIndex = _this.state.currentIndex;
            var updateState = {};
            var childrenCount = Children.count(children);
            if (childrenCount + 1 === currentIndex) {
                updateState.currentIndex = 1;
            }
            else if (currentIndex === 0) {
                updateState.currentIndex = childrenCount;
            }
            updateState.animationDuration = 0;
            _this.setState(updateState);
            if (typeof onIndexChange !== "undefined") {
                var index = currentIndex - 1;
                if (currentIndex === 0) {
                    index = childrenCount - 1;
                }
                else if (currentIndex === childrenCount + 1) {
                    index = 0;
                }
                onIndexChange(index);
            }
        };
        _this.onTouchStart = function (e) {
            var animationDuration = _this.state.animationDuration;
            if (animationDuration === 0 && !_this.isDraging()) {
                _this.stopAutoScroll();
                var touch = e.touches[0];
                var dragPoints = {
                    startPoint: {
                        x: touch.clientX,
                        y: touch.clientY
                    }
                };
                _this.setState({
                    dragPoints: dragPoints,
                    wrapperOffsetLeft: _this.scrollItemsWrapper.getBoundingClientRect().left,
                    startTime: new Date().getTime()
                });
            }
        };
        _this.onTouchMove = function (e) {
            if (_this.isDraging()) {
                var touch = e.touches[0];
                var endPoint = {
                    x: touch.clientX,
                    y: touch.clientY
                };
                var startPoint = _this.state.dragPoints.startPoint;
                if (Math.abs(endPoint.y - startPoint.y) > Math.abs(endPoint.x - startPoint.x)) {
                    _this.setState({ dragPoints: null });
                    _this.autoScroll();
                }
                else {
                    var dragPoints = Object.assign({}, _this.state.dragPoints, {
                        endPoint: endPoint
                    });
                    _this.setState({ dragPoints: dragPoints });
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };
        _this.onTouchEnd = function (e) {
            var _a = _this.state, dragPoints = _a.dragPoints, currentIndex = _a.currentIndex, containerWidth = _a.containerWidth, startTime = _a.startTime;
            if (_this.isDraging()) {
                var updateState = {
                    dragPoints: null
                };
                if (typeof dragPoints.endPoint !== "undefined") {
                    var _b = _this.props, animationDuration = _b.animationDuration, swipeSensitive = _b.swipeSensitive, speedSensitive = _b.speedSensitive;
                    var distance = dragPoints.startPoint.x - dragPoints.endPoint.x;
                    var distanceAbs = Math.abs(distance);
                    var endTime = new Date().getTime();
                    var slideSpeed = (distanceAbs * 1000) / (endTime - startTime);
                    if (distanceAbs > Math.ceil((containerWidth * swipeSensitive) / 2) ||
                        slideSpeed > speedSensitive) {
                        var scrollNumber = Math.ceil(distanceAbs / containerWidth);
                        if (distance < 0) {
                            updateState.currentIndex = currentIndex - scrollNumber;
                        }
                        else {
                            updateState.currentIndex = currentIndex + scrollNumber;
                        }
                    }
                    if (updateState.currentIndex < 0) {
                        updateState.currentIndex = 0;
                    }
                    if (updateState.currentIndex > _this.getNodeCount() - 1) {
                        updateState.currentIndex = _this.getNodeCount() - 1;
                    }
                    var duration = Math.ceil((distanceAbs / containerWidth) * animationDuration);
                    updateState.animationDuration =
                        duration > animationDuration
                            ? animationDuration - (duration % animationDuration)
                            : duration < 50
                                ? 50
                                : duration;
                }
                _this.setState(updateState);
                _this.autoScroll();
            }
            if (dragPoints === null || typeof dragPoints.endPoint !== "undefined") {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        _this.onWindowScroll = function () {
            clearTimeout(_this.windowScrollTimeoutId);
            _this.windowScrollTimeoutId = setTimeout(function () {
                if (_this.isCotainerInCurrentScreen()) {
                    _this.isStop = false;
                }
                else {
                    _this.isStop = true;
                }
            }, 80);
        };
        _this.onResize = function () {
            _this.setState({ containerWidth: _this.container.getBoundingClientRect().width });
        };
        _this.bindContainerRef = function (me) {
            _this.container = me;
        };
        _this.bindScrollItemsWrapperRef = function (me) {
            _this.scrollItemsWrapper = me;
        };
        return _this;
    }
    BetterSwipe.prototype.getNodeCount = function () {
        return Children.count(this.props.children) + 2;
    };
    BetterSwipe.prototype.isCotainerInCurrentScreen = function () {
        return this.container.getBoundingClientRect().bottom >= 0;
    };
    BetterSwipe.prototype.scrollItemsWrapperStyle = function () {
        var _a = this.state, currentIndex = _a.currentIndex, dragPoints = _a.dragPoints, animationDuration = _a.animationDuration, containerWidth = _a.containerWidth;
        var style = {};
        style.width = this.getNodeCount() + "00%";
        var wrapperOffsetLeft = -1 * currentIndex * containerWidth;
        if (this.isDraging()) {
            var _b = dragPoints, endPoint = _b.endPoint, startPoint = _b.startPoint;
            var distance = typeof endPoint === "undefined" ? 0 : startPoint.x - endPoint.x;
            style.transform = "translate3d(" + (wrapperOffsetLeft - distance) + "px,0,0)";
        }
        else {
            style.transform =
                currentIndex === 0 ? "translate3d(0,0,0)" : "translate3d(" + wrapperOffsetLeft + "px,0,0)";
            style.transitionDuration = animationDuration + "ms";
        }
        style.WebkitTransform = style.transform;
        style.transitionTimingFunction = "ease-out";
        return style;
    };
    BetterSwipe.prototype.isDraging = function () {
        return this.state.dragPoints !== null;
    };
    BetterSwipe.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, style = _a.style;
        var childrenNodes = Children.toArray(children);
        if (childrenNodes.length === 1) {
            return (React.createElement("div", { className: className, ref: this.bindContainerRef }, children));
        }
        return (React.createElement("div", { className: className, style: __assign(__assign({}, style), { overflow: "hidden", position: "relative" }), ref: this.bindContainerRef, onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd },
            React.createElement(ScrollItemsWrapper, { ref: this.bindScrollItemsWrapperRef, style: this.scrollItemsWrapperStyle(), onTransitionEnd: this.onTransitionEnd },
                childrenNodes.slice(-1)[0],
                children,
                childrenNodes[0])));
    };
    BetterSwipe.prototype.componentDidMount = function () {
        this.autoScroll();
        window.addEventListener("scroll", this.onWindowScroll);
        window.addEventListener("resize", this.onResize);
        this.setState({ containerWidth: this.container.getBoundingClientRect().width });
    };
    BetterSwipe.prototype.componentWillUnmount = function () {
        this.stopAutoScroll();
        clearTimeout(this.windowScrollTimeoutId);
        window.removeEventListener("scroll", this.onWindowScroll);
        window.removeEventListener("resize", this.onResize);
    };
    BetterSwipe.prototype.autoScroll = function () {
        var _this = this;
        var _a = this.props, duration = _a.duration, isAutoSwipe = _a.isAutoSwipe;
        if (isAutoSwipe) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(function () {
                if (!_this.isStop && document.visibilityState === "visible") {
                    var currentIndex = _this.state.currentIndex;
                    _this.scrollByIndex(currentIndex + 1);
                }
                _this.autoScroll();
            }, duration);
        }
    };
    BetterSwipe.prototype.stopAutoScroll = function () {
        var isAutoSwipe = this.props.isAutoSwipe;
        if (isAutoSwipe) {
            clearTimeout(this.timeoutId);
        }
    };
    BetterSwipe.prototype.scrollByIndex = function (index) {
        this.setState({
            currentIndex: index,
            animationDuration: this.props.animationDuration
        });
    };
    BetterSwipe.defaultProps = {
        duration: 4000,
        animationDuration: 600,
        swipeSensitive: 1,
        isAutoSwipe: true,
        speedSensitive: 320,
        style: {}
    };
    return BetterSwipe;
}(React.Component));
exports.default = BetterSwipe;
var templateObject_1;
